import React, { useEffect } from "react";
import { useAuth } from "context/authContext";
import { setDirection } from "context";
import { useMaterialUIController } from "context";
import i18n from "i18next";
const SignOut = () => {
  const { logout } = useAuth();
  const [controller, dispatch] = useMaterialUIController();
  const { direction } = controller;

  useEffect(() => {
    let hasLoggedOut = false;

    const performLogout = async () => {
      if (hasLoggedOut) return;
      hasLoggedOut = true;
      logout();
      if (direction === "rtl") setDirection(dispatch, "ltr");
      if (direction === "rtl") i18n.changeLanguage("en");

      window.location.href = "/authentication/sign-in";
    };

    performLogout();
  }, []); // Only run once

  return null;
};

export default SignOut;
